import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import DragHandleIcon from '@material-ui/icons/DragHandle';
import { SdmTypography } from 'components';
import { theme } from 'theme';
import SimpleRichText from '../styledComponents/SimpleRichText';
import CustomAccordion from '../styledComponents/CustomAccordion';
import BlockAccordionTitle from '../styledComponents/BlockAccordionTitle';
import translations from 'utils/translations';
import { ParagraphEnum } from 'utils/drupalEntities';
import SharedControllers from './SharedControllers';
import LabelContainer from './LabelContainer';
import NotTranslatableMsg from './NotTranslatableMsg';

const TextBlock = ({
  control,
  getValues,
  field,
  idx,
  additionalData,
  handleDelete,
  productLangCode,
  langCode,
  setInfoDialog,
  ...listeners
}) => {
  const intl = useIntl();
  const i18n = translations.productPage(intl);
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [form, setForm] = useState();
  const isEn = productLangCode === 'en';
  const isNotTranslatable = isEn && !form?.isTranslatable;

  useEffect(() => {
    if (additionalData) {
      Object.entries(additionalData).map(([k, v]) => {
        if (k === ParagraphEnum.SD_BRAND_MULTITEXT) setForm(v[0]);
      });
    }
  }, [additionalData]);

  return (
    <>
      {form && (
        <CustomAccordion
          expandIconVariant="secondary"
          onChange={(expanded) => {
            setIsAccordionOpen(expanded);
          }}
          title={
            <BlockAccordionTitle
              productLangCode={productLangCode}
              setInfoDialog={setInfoDialog}
              handleDelete={handleDelete}
              formKey={ParagraphEnum.SD_BRAND_MULTITEXT}
              formTitle={i18n.titles.textBlock}
              langCode={langCode}
            >
              <div
                style={{ width: '100%', display: 'flex', alignItems: 'center' }}
              >
                {!isAccordionOpen && productLangCode?.toLowerCase() !== 'en' ? (
                  <div {...listeners} style={{ marginRight: '5px' }}>
                    <DragHandleIcon
                      style={{
                        height: '15px',
                        color: 'gray',
                      }}
                    />
                  </div>
                ) : null}
                <div>
                  <SdmTypography
                    variant={'h3'}
                    margin={0}
                    style={{
                      color: theme.colors.primary.black,
                      textTransform: 'uppercase',
                    }}
                  >
                    {i18n.titles.textBlock}
                  </SdmTypography>
                </div>
              </div>
            </BlockAccordionTitle>
          }
        >
          <LabelContainer
            label={`${form.label}`}
            description={form.description}
            isRequired={form.isRequired}
            hideSpacer
          />
          {isNotTranslatable ? <NotTranslatableMsg /> : null}
          <SimpleRichText
            control={control}
            name={`additionalContents[${idx}][${form.name}]`}
            getValues={getValues}
            defaultValue={field[form.name]}
            disabled={isNotTranslatable}
          />
          <SharedControllers control={control} field={field} idx={idx} />
        </CustomAccordion>
      )}
    </>
  );
};

export default TextBlock;
